import React from 'react'

const SupplierContactsShort = ({ contacts }) => {
  return (
    <div>
        {
            contacts && contacts.length > 0 ?
                contacts.map(contact => {
                    return (
                        <p key={contact.id}>
                            {contact.phone} - {contact.name} ({contact.type.name})
                        </p>
                    )
                })
            : '-'
        }
    </div>
  )
}

export default SupplierContactsShort